<template>
    <span>{{message}}</span>
</template>

<script>
export default {
  name: 'trans',
  props: ['msg'],
  computed: {
    'message': function() {
        return (window.wizard_translations && window.wizard_translations[this.msg]) || 'Error: translation not found "' + this.msg + '"';
    }
  }
}
</script>



// WEBPACK FOOTER //
// Translation.vue?48093e2e